import styles from './index.module.css'

import React, { useCallback } from 'react'

import { openBriefProject } from '@disco/state-management/actions/ExplorerActions'
import { getBriefProject } from '@disco/state-management/reducers/entities/briefProjects'
import { ExplorerPane } from '@disco/types/types/explorer'
import { SelectableItem } from '@disco/types/types/selection'

import type { BriefProjectListApiItem } from 'types/brief'

import BriefDropWrapper from 'views/containers/BriefDropWrapper'

import { HoverProvider } from 'components/ui/hover-provider'
import Icon from 'components/ui/icon'
import MediaItem from 'components/ui/media-item'
import PaneItem from 'components/ui/pane-item'

import { useDispatch, useSelector } from 'hooks/use-redux'

import BriefProjectContextMenu from 'features/briefs/components/brief-project-context-menu'

type Props = {
  appearance: 'default' | 'disabled' | 'active' | 'selected' | 'player'
  project: BriefProjectListApiItem
  pane: ExplorerPane
  hideActions?: boolean
  disableHandlers?: boolean
  isOver?: boolean
  index: number
  selectedItems?: SelectableItem[]
}

const ExplorerBriefProject: React.FC<Props> = ({
  appearance,
  project,
  pane,
  disableHandlers,
  index,
  selectedItems,
}) => {
  const dispatch = useDispatch()

  const briefProject = useSelector(state =>
    getBriefProject(state, { briefProjectId: Number(project.id) }),
  )

  const handleClick = useCallback(
    e => {
      if (disableHandlers) return
      if (e.metaKey || e.ctrlKey || e.shiftKey) return
      if (!briefProject) return

      dispatch(openBriefProject(pane, index, briefProject))
    },
    [dispatch, disableHandlers, pane, index, briefProject],
  )

  if (!briefProject) return null

  return (
    <BriefDropWrapper
      project={{
        briefProjectId: project.id,
        briefProjectName: briefProject.name,
      }}
      selectedItems={selectedItems}
      pane={pane}
    >
      <HoverProvider enableTouchSupport>
        <BriefProjectContextMenu briefProjectId={String(project.id)}>
          <PaneItem
            appearance={appearance}
            content={
              <MediaItem
                media={
                  <div className={styles.artwork}>
                    <Icon type="folder" />
                  </div>
                }
                title={briefProject.name}
                caption="Brief Project"
              />
            }
            onClick={handleClick}
          />
        </BriefProjectContextMenu>
      </HoverProvider>
    </BriefDropWrapper>
  )
}

export default ExplorerBriefProject
